module.exports = __webpack_public_path__ + "static/media/01.21af286e.jpg";